import React from "react"
import { Avatar } from "antd"
import { RobotOutlined } from "@ant-design/icons"
import { GroupMember } from "firebase/groupsService"
import { getInitials } from "../utils"
import strings from "utils/strings"

interface MentionPickerProps {
	members: GroupMember[]
	mentionIndex: number
	pickerRef: React.RefObject<HTMLDivElement>
	onSelect: (member: GroupMember) => void
}

export const MentionPicker: React.FC<MentionPickerProps> = ({
	members,
	mentionIndex,
	pickerRef,
	onSelect,
}) => {
	if (members.length === 0) return null

	return (
		<div className="mention-picker" ref={pickerRef}>
			<div className="mention-picker__hint">{strings.messaging.mention}</div>
			{members.map((m, idx) => {
				const isBot = m.type === "bot"
				return (
					<div
						key={m.id}
						className={`mention-picker__item${idx === mentionIndex ? " mention-picker__item--active" : ""}${isBot ? " mention-picker__item--bot" : ""}`}
						onMouseDown={(e) => {
							e.preventDefault()
							onSelect(m)
						}}
					>
						{isBot ? (
							<div className="mention-picker__bot-avatar">
								<RobotOutlined />
							</div>
						) : (
							<Avatar
								size={26}
								style={{
									background: m.type === "backoffice" ? "#2B6CF4" : "#475569",
									fontSize: 10,
									flexShrink: 0,
								}}
							>
								{getInitials(m.name)}
							</Avatar>
						)}
						<div className="mention-picker__info">
							<span
								className={`mention-picker__name${isBot ? " mention-picker__name--bot" : ""}`}
							>
								@{m.name}
							</span>
							<span className="mention-picker__role">
								{isBot
									? strings.messaging.roleBot
									: m.type === "backoffice"
										? strings.messaging.roleBackoffice
										: strings.messaging.roleDriver}
							</span>
						</div>
					</div>
				)
			})}
		</div>
	)
}
